class QRParamLogger {
    constructor(win) {
      this.win = win;
      this.sessionKey = "bis_qr_scan";
      this.proxyEndpoint = "/apps/proxytest/qr";
    }

    getParams() {
      if (!this.win || !this.win.location) return;
      const search = this.win.location.search;
      if (!search) return;

      const params = new URLSearchParams(search);
      const showroom = params.get("showroom");
      const qrp = params.get("qrp");

      return { showroom, qrp };
    }

    hasBeenTracked(qrp) {
      try {
        return this.win.sessionStorage.getItem(this.sessionKey) === qrp;
      } catch (error) {
        console.warn("[QRParamLogger] sessionStorage unavailable", error);
        return false;
      }
    }

    markTracked(qrp) {
      try {
        this.win.sessionStorage.setItem(this.sessionKey, qrp);
      } catch (error) {
        console.warn("[QRParamLogger] unable to write sessionStorage", error);
      }
    }

    isMobile() {
      if (!this.win || !this.win.navigator) return false;
      const ua = this.win.navigator.userAgent || "";
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    }

    async sendToProxy(params) {
      if ("sendBeacon" in navigator) {
        try {
          const blob = new Blob([JSON.stringify(params)], {
            type: "application/json",
          });
          const ok = navigator.sendBeacon(this.proxyEndpoint, blob);
          if (!ok) {
            console.warn("[QRParamLogger] sendBeacon failed, falling back to fetch");
            await this.fetchFallback(params);
          }
        } catch (error) {
          console.warn("[QRParamLogger] sendBeacon error, falling back to fetch", error);
          await this.fetchFallback(params);
        }
        return;
      }

      await this.fetchFallback(params);
    }

    async fetchFallback(params) {
      try {
        const response = await fetch(this.proxyEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(params),
          credentials: "include",
        });

        const contentType = response.headers.get("Content-Type") || "";
        if (!contentType.includes("application/json")) {
          console.warn("[QRParamLogger] invalid response type");
          return;
        }

        const data = await response.json();
        if (!response.ok) {
          console.warn("[QRParamLogger] proxy error", data);
          return;
        }

        console.log("[QRParamLogger] proxy tracked", data);
      } catch (error) {
        console.error("[QRParamLogger] proxy request failed", error);
      }
    }

    async run() {
      const params = this.getParams();
      if (!params) return;

      const { showroom, qrp } = params;
      if (showroom || qrp) {
        console.log("[QRParamLogger]", { showroom, qrp });
      }

      if (!qrp) return;
      if (!this.isMobile()) {
        console.log("[QRParamLogger] desktop detected, skip proxy call");
        return;
      }

      if (this.hasBeenTracked(qrp)) {
        console.log("[QRParamLogger] already tracked", qrp);
        return;
      }

      await this.sendToProxy({ showroom, qrp });
      this.markTracked(qrp);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    new QRParamLogger(window).run();
  });